import { ReactElement } from "react"
import doctor from '../../../assets/doctor.webp'
import { Wrapper } from "../wrapper/wrapper"
import { PlainTextProps } from "./plain-text-props"
import * as S from './plain-text-style'

export function PlainText ({ id, values }: PlainTextProps): ReactElement {
  return <S.Container id={id}>
    <Wrapper>
      <S.Wrapper>
        <S.TextContainer>
          <h4>{values.title}</h4>
          <div dangerouslySetInnerHTML={{ __html: values.content }}></div>
          <S.Link href={values.button.link}>{values.button.title}</S.Link>
        </S.TextContainer>
        <img src={values.image || doctor} alt="" />
      </S.Wrapper>
    </Wrapper>
  </S.Container>
}